import api from './api';
import type { ApiResponse, CreatePlanForm, Plan } from '../types';

export const planService = {
  async getAll(activeOnly = false): Promise<Plan[]> {
    const qs = activeOnly ? '?active_only=true' : '';
    const response = await api.get<ApiResponse<Plan[]>>(`/api/plans${qs}`);
    return response.data.data;
  },

  async getById(id: string): Promise<Plan> {
    const response = await api.get<ApiResponse<Plan>>(`/api/plans/${id}`);
    return response.data.data;
  },

  async create(data: CreatePlanForm): Promise<Plan> {
    const response = await api.post<ApiResponse<Plan>>('/api/plans', data);
    return response.data.data;
  },

  async update(id: string, data: Partial<CreatePlanForm>): Promise<Plan> {
    const response = await api.put<ApiResponse<Plan>>(`/api/plans/${id}`, data);
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/plans/${id}`);
  },
};
